export default __webpack_public_path__ + "static/4-1bae75554f5813389a73814672ebd9af.jpeg";